import { Box, Text, Flex, Image as ThemedImage } from "@chakra-ui/react";
import { parseISO, format } from "date-fns";

import { Feedback } from "components/feedback";
import { Footer } from "components/footer";
import { Head } from "components/head";
import { Main } from "components/layout/main";
import { MDX } from 'components/mdx'
import { WIPStub, Heading, PylonLink, Warning } from "ui";

export const WorkInProgress = ({ title, description, icon, status, type, deprecatedAt, sunsetAt }) => {
  return (
    <>
    <Head title={title} description={description} />
    <Flex
      width="100%"
      justify="center"
      gap={{ base: 0, xl: 12 }}
      px={{ base: 4, md: 6, lg: 8 }}
    >
      <Main>
        <Box as="article">
          <Flex align="center" mb={6}>
            {icon && (
              <ThemedImage
                src={icon}
                sx={{
                  height: "40px",
                  mr: 4,
                  objectFit: "contain",
                  flexShrink: 0,
                }}
              />
            )}
            <Heading as="h1">{title}</Heading>
          </Flex>

          {description && (
            <Text fontWeight="semibold">
              {description}
            </Text>
          )}

          <MDX>
            {status === "released" &&
              <WIPStub
                featureName={title}
                featureType={type}
              />
            }

            {status === "alpha" &&
              <>
                <Heading>Under construction</Heading>
                <Text textStyle="paragraph">We're glad you're as excited about this {type} as we are!</Text>
                <Text textStyle="paragraph">Please &nbsp;
                  <PylonLink
                    pylonText={`Hi, I'm interested in the ${title} ${type}. I want to sync data ${type === "source" ? "to" : "from"} ${title} to help the team accomplish ___________. We specifically use this functionality ___________ in ${title}.`}
                    linkText="let us know"
                  />
                  &nbsp; more about your use case if you're interested.
                </Text>
              </>
            }

            {status === "deprecated" && (
              <Warning>
                This integration has been deprecated{deprecatedAt ? ` as of ${format(parseISO(deprecatedAt), "MMMM d, yyyy")}` : ""}.{" "}
                New syncs cannot be created, but existing syncs will continue to run{sunsetAt ? ` until ${format(parseISO(sunsetAt), "MMMM d, yyyy")}` : ''}.
              </Warning>
            )}
          </MDX>
        </Box>
      </Main>
      
      <Flex
        as="aside"
        display={["none", "none", "none", "none", "flex", "flex"]}
        direction="column"
        pos="sticky"
        top={"calc(var(--theme-sizes-header) + 1.5rem)"}
        width="260px"
        flexShrink={0}
        maxHeight="80vh"
      >
        <Feedback />
      </Flex>
    </Flex>

    <Footer />
    </>
  )
}
